import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";
import Header from "../PackageInfo/Header";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import Korigad1 from "../../Images/KorigadFort/kf1.jpg";
import Korigad2 from "../../Images/KorigadFort/kf2.jpg";
import Korigad3 from "../../Images/KorigadFort/kf3.jpg";
import Bhim1 from "../../Images/Bhimashankar/bb1.jpg";
import Bhim2 from "../../Images/Bhimashankar/bb2.jpg";

import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";

const itinerary = [
  {
    day: "Day 1",
    subheading: "Overnight journey to the base village",
    schedule: [
      { time: "10:30 PM", activity: "Pick-up at Hadapsar." },
      { time: "10:55 PM", activity: "Pick-up at Swargate." },
      { time: "11:20 PM", activity: "Pick-up at Vanaz Metro Station." },
      { time: "11:50 PM", activity: "Pick-up at Wakad / Hinjwadi." },
      {
        time: "12:00 AM",
        activity:
          "Continue the overnight journey toward the Kalsubai base region.",
      },
    ],
    meals: ["Light snacks / Dinner on the way"],
    notes: [
      "Pickup points are fixed and alternate stops are not available.",
      "The travel schedule may vary slightly depending on traffic and pickup delays.",
    ],
  },
  {
    day: "Day 2",
    subheading: "Summit climb and return journey",
    schedule: [
      {
        time: "04:30 AM",
        activity:
          "Reach the base village and freshen up after the overnight journey.",
      },
      {
        time: "07: AM",
        activity:
          "Enjoy breakfast and a brief safety briefing before starting the climb.",
      },
      {
        time: "06:00 AM",
        activity: "Begin the trek to the Kalsubai summit.",
      },
      {
        time: "08:30 AM",
        activity:
          "Reach the summit area and enjoy the stunning panoramic views of the Sahyadris.",
      },
      {
        time: "10:00 AM",
        activity:
          "Spend time at the peak, click photos, and soak in the mountain air.",
      },
      {
        time: "11:30 AM",
        activity: "Begin the descent back toward the base village.",
      },
      {
        time: "01:00 PM",
        activity: "Have lunch and rest before the return journey.",
      },
      {
        time: "02:00 PM",
        activity: "Start the return drive to Pune.",
      },
      { time: "08:00 PM", activity: "Approximate arrival back in Pune." },
    ],
    meals: ["Breakfast", "Lunch"],
    notes: [
      "The climb is steep and can be slippery during the monsoon, so please follow the lead and move carefully.",
      "The final timings may vary slightly depending on the group pace and weather.",
    ],
  },
];

const trekMeta = {
  inclusions: [
    "🚌 Pune to Pune Travel by Non-AC Bus",
    "🍽️ Breakfast & Tea",
    "🥘 Delicious Veg Lunch",
    "🩺 Basic First Aid & Hydration Powder",
    "🧭 Experienced Trek Lead & Guide",
    "🌿 Entry coordination and local support",
  ],
  exclusions: [
    'Any other charges not mentioned in "Inclusions"',
    "Mineral water, cold drinks, personal food, and extra snacks",
    "Personal expenses, insurance, or any additional activity costs",
  ],
  verticalCards: [
    { title: "Kalsubai Peak", image: Korigad1 },
    { title: "Mountain Trail", image: Korigad2 },
    { title: "Sahyadri View", image: Korigad3 },
    { title: "Steep Climb", image: Bhim1 },
    { title: "Scenic Landscape", image: Bhim2 },
  ],
  trekData: [
    {
      name: "Kalsubai Peak Trek",
      image: Korigad1,
      info: "Kalsubai is the highest peak in Maharashtra and one of the most famous summit treks in the Western Ghats. The trail takes you through steep stairs, rugged slopes, and scenic mountain terrain with a rewarding climb to the summit. The views from the top are spectacular, especially during the monsoon when clouds, valleys, and surrounding peaks create a dramatic landscape. This trek is ideal for adventurers who want a strong climb, a memorable sunrise, and a true Sahyadri summit experience.",
    },
  ],
  faq: [
    {
      question: "Where is Kalsubai located?",
      answer:
        "Kalsubai is located in the Ahmednagar district of Maharashtra and is the highest peak in the state.",
    },
    {
      question: "What is the difficulty level of the trek?",
      answer:
        "The Kalsubai trek is moderate to difficult. It involves a steep and continuous climb with some rocky and slippery sections, especially in the monsoon.",
    },
    {
      question: "Is this trek suitable for beginners?",
      answer:
        "It is best suited for trekkers with reasonable fitness and comfort with a challenging climb. Beginners can also do it with good preparation and stamina.",
    },
    {
      question: "Do you provide guides?",
      answer:
        "Yes, experienced trek leaders accompany the group and help ensure a safe trekking experience.",
    },
    {
      question: "Are meals included?",
      answer:
        "Yes, breakfast and lunch are included, and hydration support is provided during the trek.",
    },
    {
      question: "What are the pickup points?",
      answer:
        "Pickup points typically include Hadapsar, Swargate, Vanaz Metro Station, and Wakad or Hinjwadi depending on the route.",
    },
    {
      question: "Is there mobile network coverage?",
      answer:
        "Network connectivity is often weak in the mountain area, so be prepared to be off-grid for part of the trek.",
    },
    {
      question: "What should I carry?",
      answer:
        "Carry a small backpack, water bottle, rain cover, trekking shoes, cap, sunscreen, and personal medicines. A light extra layer is recommended for the windy summit.",
    },
  ],
};

const Kalsubai = () => {
  return (
    <div className="bg-gray-50">
      <Header trekData={trekMeta.trekData[0]} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrekBasicInfo
          trekName="Kalsubai Peak Trek"
          location="Ahmednagar, Maharashtra"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />
        <PackageInclusions />
      </div>
      <ItineraryTimeline itinerary={itinerary} />
      <ImageCardsWithVerticalView verticalCards={trekMeta.verticalCards} />
      <ModalTriggerList
        inclusions={trekMeta.inclusions}
        exclusions={trekMeta.exclusions}
        type="trek"
        faq={trekMeta.faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default Kalsubai;
